// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productShareLinkStyles } from "@insite/content-library/Components/ProductShareLink";
import { GridItemProps } from "@insite/mobius/GridItem";
import { xScreen } from "@keller/XDL/Utilities";
import { css } from "styled-components";

const gridItem: GridItemProps = {
    width: [12, 6, 6, 6, 6],
};

productShareLinkStyles.container = {
    gap: 20,
};

productShareLinkStyles.recipientNameGridItem = {
    ...gridItem,
};

productShareLinkStyles.recipientEmailGridItem = {
    ...gridItem,
};

productShareLinkStyles.yourNameGridItem = {
    ...gridItem,
};

productShareLinkStyles.yourEmailGridItem = {
    ...gridItem,
};
